import { useContext, useMemo } from 'react';
import { Loader } from '../Common/Loader';
import { CheckoutContext } from '@/context/CheckoutContext';
import { PaymentMethodEnum } from '@/types/common';
import { PaymentMethodsToShowLoaderWhileProcessing } from '@/constants/FormByPayment';
import { shouldShowLoader } from '@/utils/conditionalRendering';

export const ProcessingLoader = () => {
  const {
    payment: { isInPaymentProcess, isExpressPaymentInProcess },
    paymentMethodSelected,
    otherMethodSelected,
    featureFlags,
    threeDSSecurityState: { show3DSForm },
  } = useContext(CheckoutContext);

  const selectedMethod = useMemo(() => {
    return paymentMethodSelected === PaymentMethodEnum.OTHER ? otherMethodSelected : paymentMethodSelected;
  }, [paymentMethodSelected, otherMethodSelected]);

  if (!shouldShowLoader(featureFlags)) {
    return null;
  }

  // The 3DS challenge modal is rendered at z-150 (same as this loader). For
  // express wallets (GPay/ApplePay) `isExpressPaymentInProcess` stays true
  // throughout the 3DS chain — without this gate the loader sits on top of
  // the challenge iframe and the shopper can't complete authentication.
  // Cards aren't in `PaymentMethodsToShowLoaderWhileProcessing` so they
  // were already unaffected.
  if (show3DSForm) {
    return null;
  }

  if (
    (isInPaymentProcess && PaymentMethodsToShowLoaderWhileProcessing.includes(selectedMethod as PaymentMethodEnum)) ||
    isExpressPaymentInProcess
  ) {
    return (
      <div
        data-testid="processing-loader"
        className="fixed inset-0 bg-base-black/50 flex items-center justify-center z-150"
      >
        <Loader />
      </div>
    );
  }
  return null;
};
